import { render, staticRenderFns } from "./superlist.vue?vue&type=template&id=4b61a428"
import script from "./superlist.vue?vue&type=script&lang=js"
export * from "./superlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports